<template>
      <div class="tab-wrapper grid grid-cols-1 sm:grid-cols-2 sm:gap-x-8 gap-4">
        <div class="col-start-1 order-1 sm:order-1 row-start-1 sm:row-start-1">
          <div class="form">
            <label for="columns">{{ $t('columns') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_columns')"></feather></label>
            <multiselect name="columns" v-model="selectedColumns" @select="onSort(); addStackByColumn()" @remove="checkOrder($event); onSort()" :multiple="true" :options="columnsWithoutGroupBy" label="label" track-by="name" :searchable="true" :close-on-select="false" :show-labels="false" :placeholder="$t('select')">
              <template #selection="{remove}">
                <draggable v-model="selectedColumns" group="columns" @start="drag=true" @end="drag=false" @sort="onSort()" tag="ul" :forceFallback="true">
                  <li class="customselect__tag" v-for="value in selectedColumns" :key="value.name">{{ value.name }}   <i v-if="(selectedStackBy === null || value.name !== selectedStackBy.name) && selectedColumns.length !== 1" class="multiselect__tag-icon" @click.self="remove(value)"></i></li>
                </draggable>
              </template>
            </multiselect>
          </div>
        </div>
        <div class="col-start-1 order-1 sm:order-1 row-start-2 sm:col-start-2 sm:row-start-1">
          <div class="form">
            <label for="groupBy">{{ $t('group_by') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_group_by')"></feather></label>
            <multiselect name="groupBy" :multiple="false" v-model="selectedGroupBy" :options="columns" label="label" track-by="name" :searchable="true" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
          </div>
          <div class="form">
            <label for="order_by">{{ $t('order_by') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_order')"></feather></label>
            <multiselect name="order_by" :value="orderBy" @select="setOrderBy($event)" @remove="checkOrder($event)" :multiple="true" label="label" track-by="name" :options="sortOptions" :searchable="true" :close-on-select="false" :show-labels="false" :placeholder="$t('select')"></multiselect>
            <ul class="mt-2">
              <li v-for="column in orderBy" :key="column.name" class="flex justify-between items-center mt-2">
                <div class="flex items-center">
                  <svg class="h-auto has-tooltip mr-2 w-6" v-if="column.order_by == 'desc'" v-tooltip="column.order_by"  width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
                                          <g transform="translate(128 128) scale(0.72 0.72)" style="">
                                                <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)" >
                                                      <path d="M 88 21.078 H 33.078 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 H 88 c 1.104 0 2 0.896 2 2 S 89.104 21.078 88 21.078 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 74.707 38.359 H 33.078 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 41.629 c 1.104 0 2 0.896 2 2 S 75.812 38.359 74.707 38.359 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 61.413 55.641 H 33.078 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 28.335 c 1.104 0 2 0.896 2 2 S 62.518 55.641 61.413 55.641 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 48.12 72.922 H 33.078 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 H 48.12 c 1.104 0 2 0.896 2 2 S 49.225 72.922 48.12 72.922 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 10.835 72.922 c -1.104 0 -2 -0.896 -2 -2 V 19.078 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 51.844 C 12.835 72.026 11.939 72.922 10.835 72.922 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 10.835 72.922 c -0.512 0 -1.024 -0.195 -1.414 -0.586 l -8.835 -8.835 c -0.781 -0.781 -0.781 -2.047 0 -2.828 c 0.78 -0.781 2.048 -0.781 2.828 0 l 7.421 7.421 l 7.421 -7.421 c 0.78 -0.781 2.048 -0.781 2.828 0 c 0.781 0.781 0.781 2.047 0 2.828 l -8.835 8.835 C 11.859 72.727 11.347 72.922 10.835 72.922 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                </g>
                                          </g>
                                    </svg>
                                    <svg class="h-auto has-tooltip mr-2 w-6" v-else-if="column.order_by == 'asc'" v-tooltip="column.order_by" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
                                          <g transform="translate(128 128) scale(0.72 0.72)" style="">
                                                <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)" >
                                                      <path d="M 88 21.078 H 33.078 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 H 88 c 1.104 0 2 0.896 2 2 S 89.104 21.078 88 21.078 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 74.707 38.359 H 33.078 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 41.629 c 1.104 0 2 0.896 2 2 S 75.812 38.359 74.707 38.359 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 61.413 55.641 H 33.078 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 28.335 c 1.104 0 2 0.896 2 2 S 62.518 55.641 61.413 55.641 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 48.12 72.922 H 33.078 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 H 48.12 c 1.104 0 2 0.896 2 2 S 49.225 72.922 48.12 72.922 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 10.835 72.922 c -1.104 0 -2 -0.896 -2 -2 V 19.078 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 51.844 C 12.835 72.026 11.939 72.922 10.835 72.922 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                      <path d="M 19.67 29.913 c -0.512 0 -1.024 -0.195 -1.414 -0.586 l -7.421 -7.42 l -7.421 7.42 c -0.78 0.781 -2.048 0.781 -2.828 0 c -0.781 -0.781 -0.781 -2.047 0 -2.828 l 8.835 -8.835 c 0.78 -0.781 2.048 -0.781 2.828 0 l 8.835 8.835 c 0.781 0.781 0.781 2.047 0 2.828 C 20.694 29.718 20.182 29.913 19.67 29.913 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                                </g>
                                          </g>
                                    </svg>
                                    <span>{{$t(column.name)}}</span>
                              </div>
                              <div class="order-change" @click="setOrderBy(column, column.order_by === 'desc' ? 'asc' : 'desc')">
                                    <button class="border-2 hover:bg-navy hover:text-white px-4 py-2 rounded-full text-sm">Change to <strong>{{ column.order_by === 'desc' ? 'asc' : 'desc' }}</strong></button>
                              </div>
                        </li>
                  </ul>
            </div>
          <div class="form">
            <label for="chart">{{ $t('chart') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_chart')"></feather></label>
            <multiselect name="chart" v-model="selectedChart" label="name" track-by="id" :multiple="false" :options="allPossibleCharts" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
          </div>
          <div class="form" v-if="checkAggregateVisible() && chartName === 'StackedBarChart'">
            <label for="stackBy">{{ $t('stack_by') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_stack_by')"></feather></label>
            <multiselect name="stackBy" :multiple="false" v-model="selectedStackBy" :options="columnsWithoutGroupBy" label="label" track-by="name" :searchable="true" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
          </div>
          <div class="form">
            <label for="map">{{ $t('map') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_map')"></feather></label>
            <multiselect name="map" v-model="map" :options="['Show','Hide']" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
          </div>
          <div class="form" v-show="false">
            <label for="aggregate">{{ $t('additional_dates_grouping') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_additional_dates_grouping')"></feather></label>
            <multiselect name="additionalGroupBy" :value="additionalGroupBy" @select="setAdditionalGrouping($event)" @remove="checkAdditionalGrouping($event)" label="label" track-by="name" :multiple="true" :options="dateColumns" :searchable="true" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
            <ul class="mt-2">
              <li v-for="column in additionalGroupBy" :key="column.name" class="flex justify-between items-center mt-2">
                <div class="flex items-center">
                  <span>{{$t(column.name)}}</span>
                </div>
                <div class="addGroup-change">
                  <multiselect :value="column.additionalGroupBy" @select="setGroupingType($event, column)" @remove="checkGroupingType($event, column)" label="name" track-by="model" :multiple="true" :options="allAdditionalGroupBy" :searchable="false" :close-on-select="false" :show-labels="false" :placeholder="$t('select')"></multiselect>
                </div>
              </li>
            </ul>
          </div>
          <div class="form" v-show="false">
            <label for="aggregate">{{ $t('aggregate') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_aggregate')"></feather></label>
            <multiselect name="aggregate" :value="aggregate" @select="setAggregate($event)" @remove="checkAggregate($event)" label="label" track-by="name" :multiple="true" :options="aggregateColumns" :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Select"></multiselect>
            <ul class="mt-2">
              <li v-for="column in aggregate" :key="column.name" class="flex justify-between items-center mt-2">
                <div class="flex items-center">
                  <span>{{$t(column.name)}}</span>
                </div>
                <div>
                  <multiselect :value="column.aggregate" @select="setAggregateType($event, column)" @remove="checkAggregateType($event, column)" label="name" track-by="model" :multiple="true" :options="allAggregates" :searchable="false" :close-on-select="false" :show-labels="false" placeholder="Select"></multiselect>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import draggable from "vuedraggable";

export default {
      data(){
            return {


            }
      },
      components: {
            draggable
      },
      computed: {
            ...mapGetters([
                  'allColumns',
                  'newReport',
                  'allAggregates',
                  'allAggregateColumns',
                  'allCharts',
                  'allDateColumns',
                  'allAdditionalGroupBy',
                  'chartName'
            ]),
            allPossibleCharts (){
              if (!this.checkAggregateVisible()) {
                return this.allCharts.filter((chartType) => chartType.name !== 'Stacked Bar Chart')
              }
              return this.allCharts
            },
            aggregateColumns (){
              return this.allAggregateColumns.filter(column => {
                return this.newReport.service_name == column.service
              }).map(column => {
                return {name: column.name, type: column.type, label: this.$t(column.name, 1)}
              })
            },
            dateColumns (){
              return this.allDateColumns.filter(column => {
                return this.newReport.service_name == column.service
              }).map(column => {
                return {name: column.name, type: column.type, label: this.$t(column.name)}
              })
            },
            columns (){
                  return this.allColumns.filter(column => {
                    return this.newReport.service_name == column.service
                  }).map(column => {
                        return {name: column.name, type: column.type, label: this.$t(column.name)}
                  })
            },
            columnsWithoutGroupBy (){
                  let columnsWithoutGroupBy = []
                  let selectedGroupBy = Array.isArray(this.selectedGroupBy) ? this.selectedGroupBy[0] : this.selectedGroupBy
                  if (selectedGroupBy === null) {
                    return this.columns
                  }
                  this.columns.forEach((column) => {
                    if (typeof selectedGroupBy === 'object' && column.name === selectedGroupBy.name) {
                      return
                    }
                    columnsWithoutGroupBy.push(column)
                  })
                  return columnsWithoutGroupBy
            },
            selectedGroupBy: {
                  get() {
                        return this.newReport.group_by
                  },
                  set(value) {
                        this.setNewReportItem({group_by: value})
                  }
            },
            selectedChart: {
                  get() {
                        if(this.newReport.chart_id !== null) {
                              return this.allCharts.find(chart => chart.id === this.newReport.chart_id)
                        } else {
                              return null
                        }
                  },
                  set(value) {
                        if(value === null){
                              this.setNewReportItem({chart_id: null})
                              this.setNewReportItem({chart_name: null})
                        } else {
                              this.setNewReportItem({chart_id: value.id})
                              this.setNewReportItem({chart_name: value.name})
                        }
                  }
            },
            selectedStackBy: {
                  get() {
                        return this.newReport.stack_by
                  },
                  set(value) {
                        this.setNewReportItem({stack_by: value})
                  }
            },
            selectedColumns: {
                  get() {
                        return this.newReport.view_columns
                  },
                  set(value) {
                        this.setNewReportItem({view_columns: value})
                  }
            },
            sortOptions(){
                  if(!this.selectedColumns.length){
                        return this.allColumns.filter(column => {
                          return this.newReport.service_name == column.service
                        }).map(column => {
                          return {name: column.name, type: column.type, label: this.$t(column.name, 1)}
                        })
                  } else {
                        return this.newReport.view_columns
                  }
            },
            orderBy() {
                  return this.newReport.order_by
            },
            aggregate() {
                  return this.newReport.aggregate
            },
            additionalGroupBy() {
                  return this.newReport.additionalGroupBy
            },
            map: {
                get() {
                    if(this.newReport.map === true) {
                        return 'Show'
                    } else if (this.newReport.map === false || this.newReport.map === null) {
                        return 'Hide'
                    } else {
                        return null
                    }
                },
                set(value) {
                    if(value === null || value === 'Hide'){
                        this.setNewReportItem({map: false})
                    } else {
                        this.setNewReportItem({map: true})
                    }
                }
            },
      },
      methods: {
            ...mapMutations({
                  setNewReportItem: 'setNewReportItem',
                  setColumnOrder: 'setColumnOrder'
            }),
            setOrderBy(value, order = 'desc'){
                  const tempArray = [...this.orderBy ? this.orderBy : '']
                  const index = this.orderBy.findIndex(item => item.name == value.name)
                  const el = {
                        name: value.name,
                        order_by: order,
                  }
                  if (index != -1) {
                        tempArray.splice(index, 1, el)
                  } else {
                        tempArray.push(el)
                  }
                  this.setNewReportItem({order_by: tempArray})
            },
            checkOrder(value){
                  const tempArray = [...this.orderBy ? this.orderBy : '']
                  let index;
                  if (typeof value === 'string' || value instanceof String) {
                        // it's a string
                        index = tempArray.findIndex(item => item.name == value)
                  }
                  else {
                        // it's something else
                        index = tempArray.findIndex(item => item.name == value.name)
                  }
                  if (index != -1) {
                        tempArray.splice(index, 1)
                        this.setNewReportItem({order_by: tempArray})
                  }
            },
            onSort(){
                let newColumnOrder = [];
                this.selectedColumns.forEach(column => newColumnOrder.push(column.name))
                this.setColumnOrder({columns: newColumnOrder, groupByLength: Array.isArray(this.newReport.group_by) ? this.newReport.group_by.length : (this.newReport.group_by === null ? 0: 1)})
            },
            setAggregate(value){
                const tempAggrArray = [...this.aggregate ? this.aggregate : '']
                const index = this.aggregate.findIndex(item => item.name == value.name)
                const el = {
                  name: value.name,
                  label: this.$t(value.name),
                  type: value.type,
                  aggregate: [this.allAggregates[0]]
                }
                if (index != -1) {
                  tempAggrArray.splice(index, 1, el)
                } else {
                  tempAggrArray.push(el)
                }
                this.setNewReportItem({aggregate: tempAggrArray})
            },
            checkAggregate(value){
                const tempAggrArray = [...this.aggregate ? this.aggregate : '']
                let index;
                if (typeof value === 'string' || value instanceof String) {
                  // it's a string
                  index = tempAggrArray.findIndex(item => item.name == value)
                }
                else {
                  // it's something else
                  index = tempAggrArray.findIndex(item => item.name == value.name)
                }
                if (index != -1) {
                  tempAggrArray.splice(index, 1)
                  this.setNewReportItem({aggregate: tempAggrArray})
                }
            },
            setAdditionalGrouping(value){
                const tempAddArray = [...this.additionalGroupBy ? this.additionalGroupBy : '']
                const index = this.additionalGroupBy.findIndex(item => item.name == value.name)
                const el = {
                  name: value.name,
                  label: this.$t(value.name),
                  type: value.type,
                  additionalGroupBy: [this.allAdditionalGroupBy[0]]
                }

                if (index != -1) {
                  tempAddArray.splice(index, 1, el)
                } else {
                  tempAddArray.push(el)
                }
                this.setNewReportItem({additionalGroupBy: tempAddArray})
            },
            checkAdditionalGrouping(value){
                const tempAddArray = [...this.additionalGroupBy ? this.additionalGroupBy : '']
                let index;
                if (typeof value === 'string' || value instanceof String) {
                  // it's a string
                  index = tempAddArray.findIndex(item => item.name == value)
                }
                else {
                  // it's something else
                  index = tempAddArray.findIndex(item => item.name == value.name)
                }
                if (index != -1) {
                  tempAddArray.splice(index, 1)
                  this.setNewReportItem({additionalGroupBy: tempAddArray})
                }
            },
            setAggregateType(value, column){
              const tempAggrArray = [...this.aggregate ? this.aggregate : '']
              const index = this.aggregate.findIndex(item => item.name == column.name)
              if (index != -1) {
                let el = tempAggrArray[index]
                if (Array.isArray(el.aggregate)) {
                  let aggIndex = el.aggregate.findIndex(item => item.model == value.model)
                  if (aggIndex == -1) {
                    el.aggregate.push(value)
                  }
                }
                tempAggrArray.splice(index, 1, el)
              } else {
                let el = {
                  name: column.name,
                  type: column.type,
                  label: column.name,
                  aggregate: [value]
                }
                tempAggrArray.push(el)
              }
              this.setNewReportItem({aggregate: tempAggrArray})
            },
            checkAggregateType(value, column){
              const tempAggrArray = [...this.aggregate ? this.aggregate : '']
              let index = tempAggrArray.findIndex(item => item.name == column.name)
              if (index != -1) {
                let el = tempAggrArray[index]
                if (Array.isArray(el.aggregate)) {
                  const subIndex = el.aggregate.findIndex(item => item.model == value.model)
                  if (subIndex != -1) {
                    tempAggrArray[index].aggregate.splice(subIndex, 1);
                  }
                  if (tempAggrArray[index].aggregate.length == 0) {
                    tempAggrArray.splice(index, 1)
                  }
                }
                this.setNewReportItem({aggregate: tempAggrArray})
              }
            },
            setGroupingType(value, column){
              const tempAddArray = [...this.additionalGroupBy ? this.additionalGroupBy : '']
              const index = this.additionalGroupBy.findIndex(item => item.name == column.name)
              if (index != -1) {
                let el = tempAddArray[index]
                if (Array.isArray(el.additionalGroupBy)) {
                  let aggIndex = el.additionalGroupBy.findIndex(item => item.model == value.model)
                  if (aggIndex == -1) {
                    el.additionalGroupBy.push(value)
                  }
                }
                tempAddArray.splice(index, 1, el)
              } else {
                let el = {
                  name: column.name,
                  type: column.type,
                  label: column.name,
                  additionalGroupBy: [value]
                }
                tempAddArray.push(el)
              }
              this.setNewReportItem({additionalGroupBy: tempAddArray})
            },
            checkGroupingType(value, column){
              const tempAddArray = [...this.additionalGroupBy ? this.additionalGroupBy : '']
              let index = tempAddArray.findIndex(item => item.name == column.name)
              if (index != -1) {
                let el = tempAddArray[index]
                if (Array.isArray(el.additionalGroupBy)) {
                  const subIndex = el.additionalGroupBy.findIndex(item => item.model == value.model)
                  if (subIndex != -1) {
                    tempAddArray[index].additionalGroupBy.splice(subIndex, 1);
                  }
                  if (tempAddArray[index].additionalGroupBy.length == 0) {
                    tempAddArray.splice(index, 1)
                  }
                }
                this.setNewReportItem({additionalGroupBy: tempAddArray})
              }
            },
            checkAggregateVisible(){
              return this.selectedGroupBy!==null && (typeof this.selectedGroupBy === 'object' && !Array.isArray(this.selectedGroupBy) && this.selectedGroupBy.name != null || Array.isArray(this.selectedGroupBy) && this.selectedGroupBy.length>0)
            },
            addStackByColumn(){
              if (this.selectedStackBy !== null && this.selectedColumns.length !== 0 && this.selectedColumns.find((element) => element.name === this.selectedStackBy.name) === undefined) {
                let temp = this.selectedColumns //it has to be updated this way, otherwise selectedColumns.set() doesn't run
                temp.push(this.columns.find(column => column.name === this.selectedStackBy.name))
                this.selectedColumns = temp
                this.onSort()
              }
            },
      },
      watch: {
            columnsWithoutGroupBy(){
                if (this.selectedStackBy !== null && typeof this.selectedStackBy === 'object' && this.selectedStackBy.name === this.selectedGroupBy.name) {
                    this.selectedStackBy = null
                }
                let selectedGroupBy = Array.isArray(this.selectedGroupBy) ? this.selectedGroupBy[0] : this.selectedGroupBy
                this.selectedColumns = this.selectedColumns.filter((el) => {
                    return selectedGroupBy === null || (typeof selectedGroupBy === 'object' && el.name !== selectedGroupBy.name)
                })
                this.onSort()
            },
            selectedChart(){
                if (this.chartName !== 'StackedBarChart') {
                    this.selectedStackBy = null
                }
            },
            selectedStackBy() {
                this.addStackByColumn()
                this.setNewReportItem({aggregate: []})
            },
            selectedGroupBy() {
                if (!this.checkAggregateVisible() && this.chartName === 'StackedBarChart') {
                  this.selectedChart = null
                }
            }
      }
}
</script>

<style lang="sass">
.customselect__tag
      position: relative
      padding: 4px 26px 4px 10px
      border-radius: 5px
      margin-right: 10px
      line-height: 1
      margin-bottom: 5px
      white-space: nowrap
      overflow: hidden
      max-width: 100%
      text-overflow: ellipsis
.addGroup-change
      min-width: 130px
</style>
